import React from "react";

// import TuneIcon from "@mui/icons-material/Tune";
import { Typography } from "@mui/material";
import { ProgressOverlay } from "components/Progress-overlay/ProgressOverlay";
import { MaterialTooltip } from "components/tooltips/MaterialTooltip";
import { useFormatNumericHook } from "hooks";
import { CubicData } from "store/types";
import { formatCubicValue } from "utils";

export const KPI: React.FC<CubicData> = ({ title, value, tooltip, apply_number_format, orig_value, postfix }) => {
  const formatNumeric = useFormatNumericHook();
  // const openPrompt = usePrompt();

  // const { loading, action } = useActionHook(async (data: { title: string; filter: string }) => {
  //   console.log(data);
  //   await new Promise((resolve) => {
  //     setTimeout(() => {
  //       resolve(1);
  //     }, 1000);
  //   });
  // });

  // const onMenuClick = async (anchorEl: HTMLElement) => {
  //   const data = await openPrompt({
  //     Component: KPISectionMenu,
  //     componentType: "popover",
  //     anchorEl,
  //     props: {
  //       filter: cubic.filter,
  //       title: cubic.title
  //     }
  //   });

  //   if (!data) return;

  //   action(data);
  // };

  return (
    <ProgressOverlay
      inProgress={false}
      containerSX={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        p: "8px 10px",
        border: "1px solid #DBE8F5",
        flexGrow: 1,
        flex: "calc(33% - 5px)",
        position: "relative"
      }}
    >
      <Typography sx={{ textAlign: "center", fontSize: "15px", lineHeight: "20px", color: "#496682", fontWeight: 400 }}>
        {title}
      </Typography>
      <MaterialTooltip isShow={Boolean(tooltip)} title={tooltip}>
        <Typography
          sx={{ textAlign: "center", fontSize: "15px", lineHeight: "20px", color: "#071F35", fontWeight: 700 }}
        >
          {formatCubicValue({ apply_number_format, orig_value, postfix, tooltip, value }, formatNumeric)}
        </Typography>
      </MaterialTooltip>
      {/* <RoleComponentGuard availableRoles={[RoleName.Admin, RoleName.Analyst]}>
        <IconButton
          onClick={(e) => onMenuClick(e.currentTarget)}
          sx={{
            position: "absolute",
            right: "2px",
            top: "2px",
            zIndex: 10,
            transition: "opacity .15s linear"
          }}
        >
          <TuneIcon sx={{ height: 20, width: 20, color: "#5d7782" }} />
        </IconButton>
      </RoleComponentGuard> */}
    </ProgressOverlay>
  );
};
